// api returns absolute urls pointed to the wrong domain,
// so we have to convert them to a relative url...
export default function fixImageUrl(url) {
  const splitUrl = url.split('/');
  splitUrl.splice(0, 3);
  return `/${splitUrl.join('/')}`;
}
